import React from 'react'
import { NavLink } from 'react-router-dom'

const SchoolCard = ({ imgsrc, title, text }) => {
    return (
        <>
            <div className="col-lg-4 col-md-6 col-sm-12 mx-auto col-xs-12 ">
                <div class="card shadow-sm" >
                    <img class="card-img-top img-responsive" src={imgsrc} alt="Card image cap" style={{ height: '14rem' }} />
                    <div class="card-body ">
                        <div className="d-flex flex-column justify-content-between">
                            <div className=''>
                                <h5 class="card-title font-weight-bold">{title}</h5>
                                <p className="card-text">{text}</p>
                            </div>
                            <div className="text-center my-3 ">
                                <NavLink to={`/school-courses/${title}`} class="btn btn-block 
                            font-weight-bold border border-2 rounded 
                            border-dark text-dark btn-explore" >
                                    Explore
                                <i class="fa fa-arrow-right text-dark"></i>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default SchoolCard
